import React from 'react'

export function RoomFigurines({nodes, materials, ...props}) {
    return (
        <group {...props} dispose={null} name='figurines'>
            <mesh
                name='jhin_body'
                geometry={nodes.Jhin001_1.geometry}
                material={materials.jhin}
            />
            <mesh
                name='jhin_mask'
                geometry={nodes.Jhin001_2.geometry}
                material={materials.jhin_mask}
            />
            <mesh
                name='jhin_weapons'
                geometry={nodes.Jhin001_3.geometry}
                material={materials.jhin_weapons}
            />
            <mesh
                name='luigi_body'
                geometry={nodes.Luigi001_1.geometry}
                material={materials.luigi}
            />
            <mesh
                name='luigi_eyes'
                geometry={nodes.Luigi001_2.geometry}
                material={materials.luigi_eye}
            />
            <mesh
                name='sivir_weapon'
                geometry={nodes.Sivir001_1.geometry}
                material={materials.sivir_weapon}
            />
            <mesh
                name='sivir_body'
                geometry={nodes.Sivir001_2.geometry}
                material={materials.sivir}
            />
        </group>
    )
}